import { useAtom } from 'jotai';
import { InsufficientCreditsModal as InsufficientCreditsModalUI } from '@workspace/ui/components/insufficient-credits-modal';
import { insufficientCreditsAtom, openBillingForCredits } from '@/lib/credit-guard';

export function InsufficientCreditsModal() {
  const [details, setDetails] = useAtom(insufficientCreditsAtom);

  return (
    <InsufficientCreditsModalUI
      open={Boolean(details)}
      onOpenChange={(open) => {
        if (!open) setDetails(null);
      }}
      onTopUp={() => openBillingForCredits(details)}
    />
  );
}
